import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
} from "react-icons/fa";
import {
  MdLocationOn,
  MdPhone,
  MdEmail,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import "../styles/footer.css";

const footerLinks = [
  {
    heading: "About Us",
    links: [
      { label: "ISKCON Delhi", to: "/about/iskcon-delhi" },
      { label: "What is ISKCON?", to: "/about/what-is-iskcon" },
      { label: "Srila Prabhupada", to: "/about/srila-prabhupada" },
      { label: "Blog", to: "/blog" },
      { label: "Privacy Policy", to: "/privacy-policy" },
      { label: "Terms & Conditions", to: "/terms-and-conditions" },
    ],
  },
  {
    heading: "Booking",
    links: [
      { label: "Kirtan", to: "/booking/kirtan" },
      { label: "Offer Puja", to: "/booking/offer-puja" },
    ],
    subHeading: "Follow us",
    social: true,
  },
  // {
  //   heading: "YDID",
  //   links: [
  //     { label: "Brahmana Bhoj Seva", to: "/donate/brahmana-bhoja-seva" },
  //     { label: "Sri Vigraha Seva", to: "/donate/sri-vigraha-seva" },
  //     { label: "Sadhu Seva", to: "/donate/sadhu-seva" },
  //     { label: "Gyan Daan Seva", to: "/donate/gyan-daan-seva" },
  //     { label: "Rajbhog Seva", to: "/donate/rajbhoga-seva" },
  //   ],
  // },
  {
    heading: "Donate",
    links: [
      { label: "Food for Life", to: "/donate/food-for-life" },
      { label: "Nitya Seva", to: "/donate/nitya-sevak-registration" },
      { label: "Bhisma Life Patron Care", to: "/lifetime-membership" },
      { label: "Deity Service", to: "/donate/sri-vigraha-seva" },
      { label: "Devotee Prasad", to: "/donate/other-seva" },
      // { label: "Janmastami Seva", to: "/sri-krishna-janmashtami-2026" },
      { label: "General Donation", to: "/donate/other-seva" },
      { label: "Become an Affiliate", to: "#" },
    ],
  },
];

const socials = [
  { icon: <FaFacebookF />, label: "Facebook", href: "https://www.facebook.com/IskconDelhiOfferings/", },
  { icon: <FaTwitter />, label: "Twitter", href: "https://twitter.com/IskconOfferings", },
  { icon: <FaInstagram />, label: "Instagram", href: "https://www.instagram.com/iskcondelhiofferings/", },
  { icon: <FaYoutube />, label: "YouTube", href: "https://www.youtube.com/channel/UCLb7-Rq2RA7OuqjNrqwHXjg", }
];

export default function Footer() {
  return (
    <footer className="iskft-footer">
      <div className="iskft-body">
        <div className="iskft-texture" />
        <div className="container position-relative">
          <div className="iskft-divider-top" />

          <div className="iskft-links-row">
            {footerLinks.map((col, i) => (
              // <div className="col-6 col-md-2" key={i}>
              <div className="iskft-links-cont" key={i}>
                <h6 className="iskft-col-heading">{col.heading}</h6>
                <ul className="iskft-link-list">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <Link to={link.to} className="iskft-link">
                        <MdOutlineKeyboardArrowRight className="iskft-link-arrow" />
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>

                {col.social && (
                  <>
                    <h6 className="iskft-col-heading mt-4">{col.subHeading}</h6>
                    <div className="iskft-socials">
                      {socials.map((s) => (
                        <a
                          key={s.label}
                          href={s.href}
                          className="iskft-social-btn"
                          target="_blank"
                          aria-label={s.label}
                          title={s.label}
                        >
                          {s.icon}
                        </a>
                      ))}
                    </div>
                  </>
                )}
              </div>
            ))}

            {/* Contact column same as before */}
            {/* <div className="col-12 col-md-2"> */}
            <div className="iskft-links-cont">
              <h6 className="iskft-col-heading">Contact</h6>
              <div className="iskft-contact-block">
                <div className="iskft-contact-item">
                  <MdLocationOn className="iskft-contact-icon iskft-icon-loc" />
                  <div>
                    <p className="iskft-contact-title">Bhisma Department,</p>
                    <p className="iskft-contact-text">
                      ISKCON – Hare Krishna Hills, Sant Nagar, East
                      of Kailash, New Delhi
                    </p>
                  </div>
                </div>
                <div className="iskft-contact-item">
                  <MdPhone className="iskft-contact-icon iskft-icon-phone" />
                  <a href="tel:+919289774500" className="iskft-contact-link">
                    +91 9289774500
                  </a>
                </div>
                <div className="iskft-contact-item">
                  <MdEmail className="iskft-contact-icon iskft-icon-mail" />
                  <a
                    href="mailto:info@iskcondelhiofferings.com"
                    className="iskft-contact-link"
                  >
                    info@iskcondelhiofferings.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="iskft-divider-bottom" />

          <div className="iskft-bottom-bar">
            <p className="iskft-copyright">
              © 2025{" "}
              <a href="#" className="iskft-copyright-link">
                www.iskcondelhiofferings.com
              </a>{" "}
              All Rights Reserved | Design And Development By{" "}
              <a href="https://axepertexhibits.com/" className="iskft-brand-credit">
                AXEPERT EXHIBITS PVT. LTD.
              </a>
            </p>
            <div className="iskft-bottom-links">
              <Link to="#" className="iskft-bottom-link">
                Privacy Policy
              </Link>
              <span className="iskft-dot">·</span>
              <Link to="#" className="iskft-bottom-link">
                Terms
              </Link>
              <span className="iskft-dot">·</span>
              <Link to="#" className="iskft-bottom-link">
                Sitemap
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
